/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LogLevel {
    TRACE = 'Trace',
    DEBUG = 'Debug',
    INFORMATION = 'Information',
    WARNING = 'Warning',
    ERROR = 'Error',
    CRITICAL = 'Critical',
    NONE = 'None',
}
